import React from "react";

import tw from "twin.macro";
import {
  OpenCorrectZorbiLink,
  useCanUseExtension,
  useDetectBrowser,
} from "../../utils";
import { StaticImage } from "gatsby-plugin-image";

export const CTAButton = tw.a`block px-8 py-4 mb-4 text-base font-bold leading-none text-center text-white bg-purple-600 sm:inline-block sm:mb-0 sm:mr-3 hover:bg-purple-700 rounded-DEFAULT`;

const useCases = ["exams.", "tests.", "quizzes."];

const JoinOtherStudentsCaption: React.FC = () => {
  return (
    <div className="flex items-center space-x-3 overflow-hidden font-sans font-semibold align-middle">
      <div className="flex -space-x-2">
        <StaticImage
          className="inline-block w-6 h-6 rounded-full ring-2 ring-white"
          src={"../../images/userimages/discord1.png"}
          alt="Zorbi User 1"
          placeholder="blurred"
        />
        <StaticImage
          className="inline-block w-6 h-6 rounded-full ring-2 ring-white"
          src={"../../images/userimages/discord2.jpeg"}
          alt="Zorbi User 2"
          placeholder="blurred"
        />
        <StaticImage
          className="inline-block w-6 h-6 rounded-full ring-2 ring-white"
          src={"../../images/userimages/discord3.png"}
          alt="Zorbi User 3"
          placeholder="blurred"
        />
        <StaticImage
          className="inline-block w-6 h-6 rounded-full ring-2 ring-white"
          src={"../../images/userimages/discord4.jpeg"}
          alt="Zorbi User 4"
          placeholder="blurred"
        />
      </div>
      <p>
        Join <span className="text-purple-600">153,000+ other students</span>
      </p>
    </div>
  );
};

const Header = () => {
  const canUseExtension = useCanUseExtension();
  const browser = useDetectBrowser();

  return (
    <section className="pt-12 bg-top bg-no-repeat ">
      <div className="container px-4 mx-auto">
        <div className="relative py-20 lg:p-20">
          <div className="mx-auto text-center ">
            <h1 className="mb-4 text-3xl font-bold text-transparent xs:text-4xl sm:text-5xl font-heading bg-clip-text bg-gradient-to-r from-blue-600 via-purple-500 to-red-400">
              Ace your exams with <br className="hidden lg:block" />
              <span>the most efficient way to study</span>
            </h1>
            <p className="mb-8 text-base leading-relaxed sm:text-lg lg:text-xl text-blueGray-600">
              Zorbi makes studying easy by only showing you flashcards when you
              forget them. <br /> <br className="md:hidden" />
              It's free, backed by science, and it works on every device.
            </p>
            <div className="flex flex-col items-center justify-center space-y-4">
              <CTAButton
                className="self-center"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  OpenCorrectZorbiLink();
                }}
              >
                {canUseExtension
                  ? browser && browser.name.includes("edge")
                    ? "Add to Edge"
                    : "Add to Chrome"
                  : "Try Zorbi"}
              </CTAButton>

              <JoinOtherStudentsCaption />
              <a
                href="https://www.producthunt.com/posts/zorbi-2?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-zorbi-2"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=307864&theme=light"
                  alt="Zorbi - Make spaced repetition flashcards from Notion or Chrome | Product Hunt"
                  style={{ width: "250px", height: "54px" }}
                  width="250"
                  height="54"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-16"></div>
    </section>
  );
};

export default Header;
